import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const menuDesktop = '111px';
const menuMobile = '81px';
const menuWidthMedium = '312px';
const menuWidthLarge = '420px';

export const LanguageSwitcherContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DrawerOverlay = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: ${menuMobile};
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 4000;
  visibility: hidden;
  overflow: auto;
  opacity: 0;
  background: rgba(0, 0, 0, 0.58);
  display: flex;
  justify-content: var(--menu-position, flex-end);

  ${({ isVisible }) =>
    isVisible &&
    css`
      transition: 0.5s;
      opacity: 1;
      visibility: visible;
    `};

  ${({ isVisible }) =>
    !isVisible &&
    css`
      transition: 0.2s;
      opacity: 0;
      visibility: hidden;
    `};

  ${media.md`
    top: ${menuDesktop};
  `}
`;

export const DrawerPanel = styled.div`
  background-color: white;
  width: 100%;
  position: relative;

  ${media.md`
    max-width: ${menuWidthMedium};
  `}

  ${media.lg`
    max-width: ${menuWidthLarge};
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  margin-top: 20px;
`;

export const HeaderTitle = styled.div`
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  text-transform: uppercase;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  color: #333;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const TriggerButton = styled.button`
  padding: 0 14px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: inherit;

  :focus {
    outline: none;
  }

  .fi {
    width: 24px;
    height: 18px;
    border-radius: 2px;
  }

  .chevron-icon {
    display: none;
  }

  ${media.md`
    flex-direction: row;
    gap: 8px;
    padding: 0;

    .chevron-icon {
      display: block;
      width: 20px;
      height: 20px;
    }
  `}
`;

export const LanguageItem = styled.button`
  padding: 20px;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  background: none;
  -webkit-tap-highlight-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: ${({ theme }) => `1px solid ${theme.defaultColors.lighterGrey}`};
  width: 100%;
  cursor: pointer;
  color: ${({ theme }) => `${theme.defaultColors.fontPrimary}`};

  :focus {
    outline: none;
  }

  :hover,
  :focus {
    background: ${({ theme }) => theme.defaultColors.lighterGrey};
  }

  &.selected {
    background: ${({ theme }) => theme.defaultColors.lighterGrey};
    cursor: default;
  }

  .fi {
    width: 24px;
    height: 18px;
    border-radius: 2px;
  }
`;
